export const AUDIT_URL = "https://meetings-na2.hubspot.com/rahul-chakraborty";

export const TESTIMONIALS = [
  {
    name: "Cristina Michelini",
    role: "Product Owner",
    company: "Tofu",
    avatar:
      "https://customer-assets.emergentagent.com/job_revenue-engine-154/artifacts/kimcq2ek_Screenshot%202026-04-22%20at%202.06.50%E2%80%AFPM.png",
    metric: "Churn analysis that saved deals",
    quote:
      "The Revtitude team played a crucial part in helping us analyze our churn data, providing us both a detailed analysis of why most of our customers stalled and what preventive measures needed to be taken in order to save the deals. Their expertise in churn detection is unmatched.",
  },
  {
    name: "Ryan Barichello",
    role: "Co-founder",
    company: "Noterro",
    avatar:
      "https://customer-assets.emergentagent.com/job_revenue-engine-154/artifacts/yslojo4j_Screenshot%202026-04-22%20at%202.05.54%E2%80%AFPM.png",
    metric: "Trial → paid: 15% → 28%",
    quote:
      "We knew our trial conversions were lagging, but we did not have the data to fix it. Rahul and his team at Revtitude didn't just give us a CRM; they built us a growth engine that helped improve our trial to paid conversion from 15% to over 28%. They're easily the best systems experts we have ever worked with.",
  },
  {
    name: "Nikolai Grin",
    role: "Co-founder",
    company: "Preclose",
    avatar:
      "https://customer-assets.emergentagent.com/job_revenue-engine-154/artifacts/lkrkos63_Screenshot%202026-04-22%20at%202.08.20%E2%80%AFPM.png",
    metric: "Demo → opportunity up 92%",
    quote:
      "Rahul and his team at Revtitude were exceptional to work with. Their systems helped us improve our demo to opportunity funnel by over 92%. Almost each lead that would go through their pre-nurturing system would eventually convert into an opportunity.",
  },
  {
    name: "TJ Lokboj",
    role: "Co-founder",
    company: "SyndicationPro",
    avatar:
      "https://customer-assets.emergentagent.com/job_revenue-engine-154/artifacts/ssjjtz4f_Screenshot%202026-04-22%20at%202.08.48%E2%80%AFPM.png",
    metric: "Scaled to $2M ARR · 35% MoM",
    quote:
      "Rahul and the Revtitude team were instrumental in our journey from $0-2M in ARR. They helped establish the foundational systems and processes using HubSpot to help grow our firm 35% month over month. They were crucial in setting up the systems, the people, and the architecture to help grow our sales org to what it is today.",
  },
  {
    name: "Andrew Swiller",
    role: "Co-founder",
    company: "Lanteria",
    avatar:
      "https://customer-assets.emergentagent.com/job_revenue-engine-154/artifacts/ie7onek9_Screenshot%202026-04-22%20at%202.07.37%E2%80%AFPM.png",
    metric: "Zero-downtime HubSpot migration",
    quote:
      "We were worried about how the migration from Userlist to HubSpot would happen without any downtime, but Rahul and his team at Revtitude delivered a stellar migration without a single minute of downtime. The migration enabled us to have more visibility in our data, and enabled us to make much more data backed decisions about our business.",
  },
];
